import {
  $getBrands,
  $getModelsByBrandId,
  $getPackagesAndServices,
  $getCities
} from '@/utils/endpoints';
export const state = () => ({
  cities: [],
  brands: [],
  brandModels: [],
  packages: [],
  services: [],
  servicesAccordions: []
});

const getters = {
  brands: state => state.brands,
  countries: state => state.countries,
  brandModels: state => state.brandModels,
  services: state => state.services,
  packages: state => state.packages,
  servicesAccordions: state => state.servicesAccordions,
  cities: state => state.cities
};

const mutations = {
  setCities(state, cities) {
    state.cities = cities.filter(
      x => x.name != 'NO_DATA' && x.isHiddenOnWebsite === false
    );
  },
  setBrands(state, brands) {
    state.brands = brands;
  },
  setBrandModels(state, brandModels) {
    state.brandModels = brandModels;
  },
  setPackages: (state, packages) => {
    state.packages = packages;
  },
  setServices: (state, services) => {
    state.services = services;
  },
  setServicesAccordions(state, servicesAccordions) {
    state.servicesAccordions = servicesAccordions;
  },
  toggleServiceAccordion(state, id) {
    let serviceAccordion = state.servicesAccordions.find(
      x => x.option.id === id
    );
    serviceAccordion.isOpen = !serviceAccordion.isOpen;
  }
};
const actions = {
  getCities: async ({ commit }, countryId) => {
    const cities = await $getCities();
    commit('setCities', cities?.data || []);
  },
  getBrands: async ({ commit }) => {
    const brands = await $getBrands();
    commit('setBrands', brands?.data || []);
  },
  getBrandModels: async ({ commit }, brandId) => {
    const brandModels = await $getModelsByBrandId(brandId);
    const formattedBrandModels = brandModels?.data.map(modelObj => ({
      ...modelObj,
      modelUppercase: modelObj.name.toUpperCase()
    }));
    commit('setBrandModels', formattedBrandModels);
  },
  getPackagesAndServices: async (
    { state, commit },
    { vehicleModelId, currentCountryId, selectedCityId, labels }
  ) => {
    const res = await $getPackagesAndServices(
      vehicleModelId,
      currentCountryId,
      selectedCityId
    );
    commit('setServices', res.services);
    commit('setPackages', res.packagePrices);
    res.services?.forEach(service => {
      const key = service.name.replace(/\s/g, '');
      service.title = labels[key + 'Title'] || service.name;
      service.description = labels[key + 'Description'];
    });
    const servicesAccordions = res.services.map(service => {
      return {
        option: service,
        isOpen: false,
        isSelected: false,
        isOptional:
          service.name !== 'External Washing' &&
          service.name !== 'Internal Washing',
        isVisible: true
      };
    });
    commit('setServicesAccordions', servicesAccordions);
  }
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced
};
